// Modules
import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledBanner = styled.aside`
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    border: #f00 1px solid;

    & > div {
        background-color: #fc503c;
        width: 79%;
        height: 100%;
        display: flex;
        align-items: flex-end;
    }

    .banner__title {
        max-width: 360px;
        font-size: 50px;
        line-height: 69px;
        font-weight: 400;
        color: ${theme.colors.white};
        padding-left: 80px;
        padding-bottom: 128px;

        &--bold {
            font-weight: 600;
        }
    }

    .banner__image {
        bottom: 0;
        right: 22px;
        height: 90vh;
        position: absolute;
        z-index: 1;
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
        display: block;
    }

    @media screen and (max-width: 1400px) {
        .banner__image {
            right: -47px;
        }
    }

    @media screen and (max-width: 1200px) {
        .banner__image {
            display: none;
        }
    }
`
